var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowStock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10346",
    "data-name": "Group 10346",
    transform: "translate(-1316 -145)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_265",
    "data-name": "Ellipse 265",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1316 145)",
    fill: "#313d85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M18026.955,21264.764a1.5,1.5,0,0,1-1.494-1.494v-9.7a.75.75,0,0,1,.219-.527l2.236-2.236a.73.73,0,0,1,.529-.219h8.955a.726.726,0,0,1,.527.219l2.236,2.236a.75.75,0,0,1,.219.527v9.7a1.5,1.5,0,0,1-1.494,1.494Zm0-1.494h11.939l-.006-8.949h-11.934Zm1.057-10.443h9.82l-.742-.748h-8.336Zm-.09,7.188v-4h2v2h6v-2h2v4Z",
    transform: "translate(-16700.926 -21096.176)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowStock);
export default __webpack_public_path__ + "static/media/low-stock.2c660fdd2228e7eaab620d3f66d0afd2.svg";
export { ForwardRef as ReactComponent };